export class UXComponent {
    constructor(options = {}) {
        this.listeners = [];
        this.setVisibility = (visibility) => {
            this.visible = visibility;
            this.triggerListeners();
        };
        this.visible = options.visible || false;
    }
    reset(options = {}) {
        this.setVisibility(options.visible || false);
    }
    toggleVisibility() {
        this.setVisibility(!this.visible);
    }
    show() {
        this.setVisibility(true);
    }
    hide() {
        this.setVisibility(false);
    }
    getVisibility() {
        return this.visible;
    }
    onVisibilityChange(callback) {
        this.listeners.push(callback);
    }
    triggerListeners() {
        this.listeners.forEach((listener) => {
            listener();
        });
    }
}
//# sourceMappingURL=component.js.map